export const EMAIL_VERIFICATION_TYPES = {
	REGISTER: 'register',
	CHANGE_EMAIL: 'changeEmail',
};
